import { User } from '@prisma/client'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { AppSessionType } from '~/features/appSession/common'
import { OnboardingValues } from '../../common'
import { StepAuthorizations } from './components/StepAuthorizations'
import { StepConnection } from './components/StepConnection'
import { StepDailyFollowUp } from './components/StepDailyFollowUp'
import { StepDailySourceLeads } from './components/StepDailySourceLeads'

type Props = {
  user: User
  appSession: AppSessionType
  onSubmit: () => void
}

export const Onboarding: React.FC<Props> = ({ user, appSession, onSubmit }) => {
  const valuesDefault: Partial<OnboardingValues> = {
    emailServices: {
      provider: 'google',
    },
    daily: {
      activated: true,
      autopilot: true,
    },
    followUp: {
      activated: true,
      first: 3,
      second: 5,
    },
  }

  return (
    <>
      <CommonClient.Onboarding.Wrapper<OnboardingValues>
        appSession={appSession}
        valuesDefault={valuesDefault}
        onSubmitted={onSubmit}
        steps={[
          {
            key: 'emailServices',
            content: props => <StepConnection {...props} />,
          },
          {
            key: 'daily',
            content: props => <StepDailySourceLeads user={user} {...props} />,
          },
          {
            key: 'followUp',
            content: props => <StepDailyFollowUp user={user} {...props} />,
          },
          {
            key: 'authorizations',
            content: props => <StepAuthorizations {...props} />,
            isVisible(values) {
              return !!values.emailServices.accountGmail
            },
          },
        ]}
      />
    </>
  )
}
